import { features } from "@/mocks/manga";
import SectionTitle from "./SectionTitle";

const tone = [
  "bg-primary-100 text-primary-600",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-600",
  "bg-primary-100 text-primary-600",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-600",
];

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="核心功能"
          title="追更这件事，交给汗汗虫虫"
          desc="更新提醒、追更设置、最新章节推送、追更日历、订阅管理与自动续读，六项能力帮你把在追作品打理得井井有条。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f, i) => (
            <article
              key={f.title}
              className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <div
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${tone[i % tone.length]}`}
              >
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-5 font-heading text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{f.desc}</p>
              <a
                href="#calendar"
                className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 transition-colors hover:text-primary-700"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}